import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Button } from "antd";

import googleIcon from "../../assets/img/google-icon.svg";

export const GoogleSignInButton = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const next = searchParams.get("next");
  const href = next
    ? `/google/login/?next=${encodeURIComponent(next)}`
    : "/google/login/";

  return (
    <Button
      size="large"
      block
      icon={
        <img
          src={googleIcon}
          alt=""
          style={{ width: 20, height: 20, display: "block" }}
        />
      }
      href={href}
    >
      {t("app.googleSignin")}
    </Button>
  );
};
